<ap-panel type="primary" data-bb="ctaPanel">
    <div ap-panel-body>
        <p>{{ 'cta.different_question.intro' | apContent }}</p>

        <div class="ap-flex ap-gap-10">
            <div>
                <ap-icon-link data-bb="phoneIconLink" iconName="phone" iconSize="extra-large" [link]="'cta.phone_number' | apContent">
                    {{ 'cta.label.phone_number' | apContent }}
                </ap-icon-link>
                <p class="ap-margin-top-1">{{ 'cta.phone_number' | apContent | apPhone }}</p>
            </div>
        </div>
    </div>
</ap-panel>
